import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const ProductHotspotRoutes = defineRoute({
    record: {
        route: {
            path: "/product-hotspot",
            component: () => loadView(import("./ProductHotspotTable.vue")),
        },
    },
    create: {
        route: {
            path: "/product-hotspot/create",
            component: () => loadView(import("./ProductHotspotCreate.vue")),
        },
    },
    update: {
        route: {
            path: "/product-hotspot/update/:id",
            component: () => loadView(import("./ProductHotspotUpdate.vue")),
        },
        build(id: string) {
            return `/product-hotspot/update/${id}`;
        },
    },
});
